export const STORE_SEARCH_EVENTS = 'searchEventsStore';

export const SE_SET_OPTIONS = 'setOptions';
export const SE_SET_FILTERS = 'setFilters';
export const SE_SET_STATE = 'setState';
export const SE_SET_DEF_FILTERS = 'setDefaultFilters';
export const SE_FETCH_EVENTS = 'fetchEvents';
export const SE_FETCH_CHART_DATA = 'fetchChartData';
export const SE_FETCH_HOLIDAYS = 'fetchHolidays';
export const SE_FETCH_CURRENT_HOLIDAYS = 'fetchCurrentHolidays';

export const SE_DEFAULT_RADIUS = 1000;
